$(function(e) {
  $('.inquiry-replies .images a.popup').magnificPopup({
    type: 'image',
    closeOnContentClick: true
  })
})
